"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var calendar_state_1 = require("../classes/calendar-state");
var action_struct_1 = require("../actions/action-struct");
var moment = require("moment");
var _ = require("lodash");
function reduce(state, action) {
    if (state === void 0) { state = calendar_state_1.defaultCalendarModel; }
    switch (action.type) {
        case action_struct_1.ActionType.UpdateEventFilter: {
            var updating = true;
            var addedFilterFunction_1 = action.value;
            var eventFilter = null;
            if (state.eventFilter.some(function (filter) { return filter.key === addedFilterFunction_1.key; })) {
                eventFilter = state.eventFilter.filter(function (filter) { return !(filter.key === addedFilterFunction_1.key); }).concat([addedFilterFunction_1]);
            }
            else {
                eventFilter = state.eventFilter.concat([addedFilterFunction_1]);
            }
            var filterFunction = function (event) { return eventFilter.map(function (fil) { return fil.filter; }).every(function (f) { return f(event); }); };
            return _.assign({}, state, { eventFilter: eventFilter, filterFunction: filterFunction, updating: updating });
        }
        case action_struct_1.ActionType.ChangeProductionSeasonFilter: {
            var productionSeasonFilter = action.value;
            var updating = true;
            return _.assign({}, state, { productionSeasonFilter: productionSeasonFilter, updating: updating });
        }
        case action_struct_1.ActionType.NextMonth: {
            var newEndDate = state.endDate.clone().add(1, 'month').endOf('month');
            var newCurrMoment = state.currentDate.clone().add(1, "month");
            if (newCurrMoment.isAfter(state.endDate)) {
                return _.assign({}, state, { updating: true, specificDates: false, currentDate: newCurrMoment, endDate: newEndDate });
            }
            return _.assign({}, state, { currentDate: newCurrMoment });
        }
        case action_struct_1.ActionType.UpdateEvents: {
            var events = action.value;
            return _.assign({}, state, { updating: false, events: events });
        }
        case action_struct_1.ActionType.PreviousMonth: {
            var newStartDate = state.startDate.clone().add(-1, 'month').startOf('month');
            var newCurrMoment = state.currentDate.clone().add(-1, "month");
            if (newCurrMoment.isBefore(state.startDate)) {
                return _.assign({}, state, { updating: true, specificDates: false, currentDate: newCurrMoment, startDate: newStartDate });
            }
            return _.assign({}, state, { currentDate: newCurrMoment });
        }
        case action_struct_1.ActionType.AddDays: {
            var extendEvents = action.value.extendDays;
            if (extendEvents) {
                if (action.value.numberOfDays > 0) {
                    state.endDate = moment(state.endDate.add(action.value.numberOfDays, 'day'));
                }
                else {
                    state.startDate = moment(state.startDate.add(action.value.numberOfDays, 'day'));
                }
            }
            else {
                state.startDate = moment(state.startDate.add(action.value.numberOfDays, 'day'));
                state.endDate = moment(state.endDate.add(action.value.numberOfDays, 'day'));
            }
            var updating = true;
            return _.assign({}, state, { updating: updating, extendEvents: extendEvents, specificDates: true });
        }
        case action_struct_1.ActionType.GoToMonth: {
            var setDate = action.value.clone();
            var newStart = void 0;
            var newEnd = void 0;
            var mustUpdate = false;
            if (setDate.isBefore(state.startDate)) {
                newStart = setDate.clone().startOf("month");
                mustUpdate = true;
            }
            else {
                newStart = state.startDate.clone();
            }
            if (setDate.isAfter(state.endDate)) {
                newEnd = setDate.clone().endOf("month");
                mustUpdate = true;
            }
            else {
                newEnd = state.endDate.clone();
            }
            return _.assign({}, state, {
                updating: mustUpdate,
                specificDates: false,
                currentDate: action.value.clone(),
                startDate: newStart,
                endDate: newEnd
            });
        }
        case action_struct_1.ActionType.SetMonth: {
            state.startDate = moment(action.value.startOf('month'));
            state.endDate = moment(action.value.endOf('month'));
            var updating = true;
            return _.assign({}, state, { updating: updating, specificDates: true });
        }
        case action_struct_1.ActionType.SetDates: {
            state.startDate = action.value.startDate;
            state.endDate = action.value.endDate;
            var updating = true;
            return _.assign({}, state, { updating: updating, specificDates: true });
        }
        case action_struct_1.ActionType.EventUpdated: {
            return _.assign({}, state, { updating: false });
        }
        case action_struct_1.ActionType.BrowserNavigated: {
            state = action.value.state;
            state.updating = action.value.shouldUpdate;
            return state;
        }
        default:
            return state;
    }
}
exports.reduce = reduce;
//# sourceMappingURL=calendar-reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@adage/ace-calendar/app/reducer/calendar-reducer.js
// module id = 141
// module chunks = 0